<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12 ">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Almost Ready to Go – setup eNACH!​​</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">
                        <div class="text-center">
                            <p class="content">
                                Securely set up your eNACH mandate. This ensures timely payments and a smooth repayment
                                experience.​
                            </p>
                            <p class="content">
                                This is a secure and RBI-regulated process.​

                            </p>
                            <div class="enach-wrapper text-center mt-5">
                                <button (click)="initiatePayment()" class="btn btn-warning px-5" [disabled]="isLoading">
                                    {{ isLoading ? 'Processing...' : 'Proceed to eNACH' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>